module.exports = __webpack_public_path__ + "img/badge_color_ihe-holistic.ab55de02.svg";